import React from 'react'
import Counter from './counter'

const App = () => {
  return (
    <div>
      <Counter/>
    </div>
  )
}

export default App